import { ROLES_LIST } from '@/js/constants';
export default [{
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.summary',
  subname: '',
  href: {
    name: 'use_metrics_summary'
  },
  link: '/use-metrics/summary',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.data_management',
  subname: '',
  href: {
    name: 'use_metrics_data_management'
  },
  link: '/use-metrics/data-management',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.attributes',
  subname: '',
  href: {
    name: 'use_metrics_attributes'
  },
  link: '/use-metrics/attributes',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.audiences',
  subname: '',
  href: {
    name: 'use_metrics_audiences'
  },
  link: '/use-metrics/audiences',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.insights',
  subname: '',
  href: {
    name: 'use_metrics_insights'
  },
  link: '/use-metrics/insights',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.use_metrics_sub.mlops',
  subname: '',
  href: {
    name: 'use_metrics_mlops'
  },
  link: '/use-metrics/mlops',
  roles: []
}
/*{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.assets_corp',
    subname: '',
    href: { name: 'use_metrics_assets_corp' },
    link: '/use-metrics/assets-corp',
    roles: [],
 },
{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.maturity_government',
    subname: '',
    href: { name: 'use_metrics_maturity_government' },
    link: '/use-metrics/maturity-government',
    roles: [],
},
{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.tables_government',
    subname: '',
    href: { name: 'use_metrics_tables_government' },
    link: '/use-metrics/tables-government',
    roles: [],
 },
{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.quality_government',
    subname: '',
    href: { name: 'use_metrics_quality_government' },
    link: '/use-metrics/quality-government',
    roles: [],
 },
{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.security_government',
    subname: '',
    href: { name: 'use_metrics_security_government' },
    link: '/use-metrics/security-government',
    roles: [],
 },
{
    name: 'Assessment Report',
    key: 'menu.use_metrics_sub.dashboard_government',
    subname: '',
    href: { name: 'use_metrics_dashboard_government' },
    link: '/use-metrics/dashboard-government',
    roles: [],
 }*/];